import { render, staticRenderFns } from "./YYHistory.vue?vue&type=template&id=d12c9542&scoped=true"
import script from "./YYHistory.vue?vue&type=script&lang=js"
export * from "./YYHistory.vue?vue&type=script&lang=js"
import style0 from "./YYHistory.vue?vue&type=style&index=0&id=d12c9542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12c9542",
  null
  
)

export default component.exports